import React from 'react';
import { Card, Grid, Typography, Divider } from '@mui/material';

const CumulativeData = ({ networkListData }) => {
  if (!networkListData?.cumulative_sales_month_wise) {
    return <Typography>No data available</Typography>;
  }

  return (
    <Card sx={{ p: 2, width: '100%' }}>
      <Grid
        container
        spacing={2}
        alignItems='center'
        justifyContent='center'
      >
        {networkListData.cumulative_sales_month_wise.map((item, index) => (
          <React.Fragment key={index}>
            <Grid
              item
              xs={12}
              sm={4}
              textAlign='center'
            >
              <Typography sx={{ fontSize: 14, fontWeight: '600' }}>
                {item.primary_title}
              </Typography>
              <Typography
                variant='h6'
                fontWeight='bold'
                color='primary'
              >
                <Typography
                  variant='body2'
                  component='span'
                  color='textSecondary'
                >
                  {item.prefix_uom}{' '}
                </Typography>
                {item.sales}{' '}
                <Typography
                  variant='body2'
                  component='span'
                  color='textSecondary'
                >
                  {item.suffix_uom}
                </Typography>
              </Typography>
              <Typography
                variant='body2'
                color='textSecondary'
              >
                {item.secondary_title}
              </Typography>
            </Grid>
            {index < networkListData.cumulative_sales_month_wise.length - 1 && (
              <Divider
                orientation='vertical'
                flexItem
                sx={{ mx: 2, mt: 2 }}
              />
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Card>
  );
};

export default CumulativeData;
